import classnames from 'classnames';
import { useEffect, useState } from 'react';
import { useFuzzySearchQ } from '../../hooks/useFuzzySearch';
import { Json } from '../../types';
import { useArrows } from './PromptSuggestions.hooks';
import { Header, Suggestion, Suggestions, Wrapper } from './PromptSuggestions.style';

export type PromptSuggestionsProps = {
  items: Json[];
  prompt: string;
  isFocused?: boolean;
  onPick: (prompt: string) => void;
};

export function PromptSuggestions(props: PromptSuggestionsProps) {
  const { items = [], prompt, isFocused } = props;
  const filteredItems = useFuzzySearchQ(items, ['prompt'], prompt);
  const [selectedIndex, setSelectedIndex] = useState(0);

  useArrows(
    (key) => {
      switch (key) {
        case 'ArrowUp':
          setSelectedIndex((prev) => Math.min(prev + 1, filteredItems.length - 1));
          break;
        case 'ArrowDown':
          setSelectedIndex((prev) => Math.max(prev - 1, 0));
          break;
      }
    },
    [filteredItems]
  );

  useEffect(() => {
    setSelectedIndex(0);
  }, [filteredItems.length]);

  // useEnter(() => {
  //   const item = filteredItems[selectedIndex];
  //   if (!item) return;
  //   props.onPick(item.prompt);
  // }, [filteredItems, selectedIndex]);

  function renderSuggestion(item: Json, index: number) {
    const className = classnames('item', {
      // selected: index === selectedIndex,
    });

    return (
      <Suggestion key={item.id} className={className} onClick={() => props.onPick(item.prompt)}>
        <span>{item.id} | </span>
        {item.prompt}
      </Suggestion>
    );
  }

  // if (filteredItems.length === 0 || prompt.length > 10) {
  //   return null;
  // }

  function renderSuggestions() {
    return [...filteredItems]
      .splice(0, 10)
      .map((item: Json, index: number) => renderSuggestion(item, index));
  }

  const className = classnames('PromptSuggestions-wrapper', {
    show: filteredItems.length > 0 && prompt.length < 10 && isFocused,
  });

  return (
    <Wrapper className={className} data-testid='PromptSuggestions-wrapper'>
      <Header>Prompt ideas</Header>
      <Suggestions>{renderSuggestions()}</Suggestions>
    </Wrapper>
  );
}

export default PromptSuggestions;
